import React from "react";

const pumpkinIcon = `data:image/svg+xml,${encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>🎃</text></svg>",
)}`;

/** Swaps the tab icon for a pumpkin while mounted and restores the originals on unmount. */
export const useHalloweenFavicon = () => {
  React.useEffect(() => {
    const originals = Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]'), (link) => ({
      link,
      href: link.href,
      type: link.type,
    }));
    for (const { link } of originals) {
      link.type = "image/svg+xml";
      link.href = pumpkinIcon;
    }
    return () => {
      for (const { link, href, type } of originals) {
        link.type = type;
        link.href = href;
      }
    };
  }, []);
};
